module.exports = {
    //更新邮件的,包括删除和新增
    UPDATE_ITEM: "UPDATE_ITEM",

    //更新公告的,包括删除和新增
    UPDATE_NOTICE: "UPDATE_NOTICE",

    //红点状态
    UPDATEREDSTATUS:"UPDATEREDSTATUS",

    READ_MAIL_INFO:"READ_MAIL_INFO",

    GET_ITEM_ASSETS:"GET_ITEM_ASSETS",
};